import { render } from "./ListField.vue?vue&type=template&id=dd7f12b0&bindings={\"modelValue\":\"props\",\"type\":\"props\",\"delimiters\":\"props\",\"model\":\"data\",\"cleanValue\":\"options\"}"
import script from "./ListField.vue?vue&type=script&lang=js"
export * from "./ListField.vue?vue&type=script&lang=js"
script.render = render

export default script